import { Skeleton } from "@/shared/ui/skeleton";
import { cn } from "@/shared/lib/utils";

export function PropertyDetailLoadingState() {
  return (
    <div className="h-screen bg-gradient-to-br from-background via-background to-accent/20 flex flex-col">
      <div className="bg-gradient-to-r from-card/80 to-accent/80 backdrop-blur-sm border-b border-border flex-shrink-0">
        <div className="p-6">
          <div className="flex items-start justify-between mb-4">
            <div className="flex items-center gap-4">
              <Skeleton className="w-16 h-16 rounded-xl" />
              <div className="space-y-2">
                <div className="flex items-center gap-3">
                  <Skeleton className="h-8 w-32" />
                  <Skeleton className="h-5 w-16 rounded-full" />
                </div>
                <Skeleton className="h-4 w-72" />
                <Skeleton className="h-4 w-28" />
              </div>
            </div>

            <div className="self-center hidden md:flex items-center gap-2 flex-wrap justify-end flex-shrink-0">
              {Array.from({ length: 5 }).map((_, index) => (
                <div
                  key={index}
                  className="rounded-md border border-border/50 bg-background/80 px-3 py-1.5 min-w-[88px] space-y-1.5"
                >
                  <Skeleton className="h-3 w-16" />
                  <Skeleton className="h-4 w-10" />
                </div>
              ))}
            </div>
          </div>

          <div className="flex h-10 w-full items-center gap-2 rounded-md bg-background/50 p-1">
            {Array.from({ length: 8 }).map((_, index) => (
              <Skeleton
                key={index}
                className={cn(
                  "h-7 rounded-sm",
                  index === 2 ? "w-24" : index === 5 ? "w-28" : "w-16"
                )}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="flex-1 overflow-auto p-6 animate-fade-in">
        <Skeleton className="h-full min-h-[600px] w-full rounded-lg" />
      </div>
    </div>
  );
}
